export function formatDate (date?: string | null): string | null {
  if (date !== null && date !== undefined && date !== '') {
    const newDate = date.replace('T00:00:00', '')
    return newDate
  }

  return null
}
